import {Property} from 'csstype';

/**
 * Number of pixels the popper extends past its anchor element on each side.
 *
 * This compensates for the page-level horizontal padding that consumer
 * screens add around their content (CRM/Search/Lists all wrap their layout
 * in `padding: 0 24px`). Extending past the anchor means the bar's backdrop
 * reaches the actual edges of the canvas (sidebar end on the left, page
 * right edge on the right) rather than stopping at the inner edge of the
 * page padding.
 *
 * If a future consumer uses a different page padding, pass a custom
 * `widthCalculation` prop instead of changing this constant.
 */
const FLOATING_BAR_HORIZONTAL_OVERFLOW = 24;

/**
 * Default width calculation for FloatingPopperBar.
 *
 * Returns the anchor width plus a fixed overflow on each side so the
 * popper's outer **backdrop** layer reaches the canvas edges (rather than
 * stopping at the anchor element's edge). The inner pill sits inside the
 * backdrop and is inset by the backdrop's CSS padding.
 *
 * Falls back to 'auto' when the container width is not yet known (e.g.
 * before the first resize observation).
 *
 * Per the design spec, the bar is meant to scale with the canvas — there is
 * no max-width cap. If a consumer needs to cap the width, pass a custom
 * widthCalculation prop.
 */
export default function defaultWidthCalculation(
  width?: number
): Property.Width<number> {
  return width ? width + FLOATING_BAR_HORIZONTAL_OVERFLOW * 2 : 'auto';
}
